module.exports = __webpack_public_path__ + "img/banner_left.dec9c23f.jpg";